import { Field } from '@chakra-ui/react'
import { TextColors } from 'commons/design-system/tokens'
import type { ReactNode } from 'react'

type Props = {
	children: ReactNode
}

export const Label = ({ children }: Props) => {
	return (
		<Field.Label
			fontFamily='Montserrat'
			display='flex'
			w='fit-content'
			cursor='pointer'
			gap={1}
			mb={0}
			fontWeight='600'
			color={TextColors.QUATERNARY}
			fontSize='12px'
			textTransform='uppercase'
		>
			{children}
		</Field.Label>
	)
}
